module.exports = __webpack_public_path__ + "static/media/david.b48e3a2c.png";